import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const PatientSearchBar = ({ recentPatients, onSelectPatient }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);

  const filteredPatients = recentPatients?.filter(patient =>
    patient?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    patient?.mrn?.includes(searchQuery)
  );

  const handleSearch = (e) => {
    setSearchQuery(e?.target?.value);
    setShowSuggestions(e?.target?.value?.length > 0);
  };

  const handleSelectPatient = (patient) => {
    onSelectPatient(patient);
    setSearchQuery('');
    setShowSuggestions(false);
  };

  return (
    <div className="relative">
      <div className="relative">
        <Input
          type="search"
          placeholder="Search patients by name or MRN..."
          value={searchQuery}
          onChange={handleSearch}
          className="pl-10"
        />
        <Icon 
          name="Search" 
          size={18} 
          className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
        />
      </div>
      {showSuggestions && filteredPatients?.length > 0 && (
        <div className="absolute top-full left-0 right-0 mt-2 bg-card rounded-lg shadow-elevation-4 border border-border max-h-80 overflow-y-auto z-50">
          <div className="p-2">
            <p className="text-xs text-muted-foreground px-3 py-2">Recent Patients</p>
            {filteredPatients?.map((patient, index) => (
              <button
                key={index}
                onClick={() => handleSelectPatient(patient)}
                className="w-full flex items-center gap-3 p-3 rounded-lg text-left transition-smooth hover:bg-muted"
              >
                <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full flex-shrink-0">
                  <Icon name="User" size={18} color="var(--color-primary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground">{patient?.name}</p>
                  <p className="text-xs text-muted-foreground">MRN: {patient?.mrn} | DOB: {patient?.dob}</p>
                </div>
                <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientSearchBar;